
interface EmptyStateProps {
  query: string;
  onClearFilters: () => void;
}

const suggestions = [
  'Try searching for "Khaligraph" or "Gengetone"',
  'Browse all artists by clearing filters',
  'Check out verified artists only'
];

export default function EmptyState({ query, onClearFilters }: EmptyStateProps) {
  return (
    <div className="text-center py-12">
      <div className="w-16 h-16 mx-auto mb-4 bg-gray-100 rounded-full flex items-center justify-center">
        <i className="ri-user-search-line text-2xl text-gray-400"></i>
      </div>
      
      <h3 className="text-lg font-medium text-gray-900 mb-2">
        No artists match those filters
      </h3>
      
      {query ? (
        <p className="text-gray-500 mb-6">
          No results found for "{query}". Try adjusting your search or filters.
        </p>
      ) : (
        <p className="text-gray-500 mb-6">
          Try adjusting your filters to see more artists.
        </p>
      )}

      <div className="space-y-4">
        <button
          onClick={onClearFilters}
          className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-emerald-600 hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500 whitespace-nowrap"
        >
          Clear filters
        </button>

        <div className="text-sm text-gray-500">
          <p className="mb-2">Try these suggestions:</p>
          <ul className="space-y-1">
            {suggestions.map((suggestion, index) => (
              <li key={index}>• {suggestion}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
